import { connect } from "react-redux";

import ShipmentSearchView from "./ShipmentSearchView";
import SearchState from "./ShipmentSearchState";
import LadsState from "../lads/LadsState";

function mapStateToProps(state) {
  return {
    shipments: SearchState.selectors.getShipments(state),
    isLoading: SearchState.selectors.getIsLoading(state),
    searchCategory: SearchState.selectors.getSearchCategory(state),
    searchObj: SearchState.selectors.getSearchObj(state),
    searchFilters: SearchState.selectors.getSearchFilters(state),
    lads: LadsState.selectors.getLadsList(state),
    page: SearchState.selectors.getPage(state),
    pageSize: SearchState.selectors.getPageSize(state),
    totalPages: SearchState.selectors.getTotalPages(state),
    totalShipments: SearchState.selectors.getTotalShipments(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setPagination: (page, pageSize) =>
      dispatch(SearchState.actionCreators.setPagination(page, pageSize)),
    setSort: (sortColumn, reverse) =>
      dispatch(SearchState.actionCreators.setSort(sortColumn, reverse)),
    resetSearch: () => dispatch(SearchState.actionCreators.resetSearch()),
    pushShipmentDetailView: shipmentID =>
      dispatch({
        type: "SHIPMENT_DETAIL",
        payload: { shipment_id: shipmentID }
      })
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ShipmentSearchView);



// WEBPACK FOOTER //
// ./src/modules/shipment-search/ShipmentSearchViewContainer.js